import { IconType, SvgIcon } from './SvgIcon';

export const AngleIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path
      d="M14.1666 7.64166C14.0104 7.48646 13.7992 7.39934 13.5791 7.39934C13.3589 7.39934 13.1477 7.48646 12.9916 7.64166L9.99992 10.5917L7.04992 7.64166C6.89378 7.48646 6.68257 7.39934 6.46242 7.39934C6.24226 7.39934 6.03105 7.48646 5.87492 7.64166C5.79681 7.71913 5.73481 7.8113 5.69251 7.91285C5.6502 8.0144 5.62842 8.12332 5.62842 8.23333C5.62842 8.34334 5.6502 8.45226 5.69251 8.55381C5.73481 8.65536 5.79681 8.74753 5.87492 8.825L9.40825 12.3583C9.48572 12.4364 9.57789 12.4984 9.67944 12.5407C9.78098 12.583 9.88991 12.6048 9.99992 12.6048C10.1099 12.6048 10.2188 12.583 10.3204 12.5407C10.4219 12.4984 10.5141 12.4364 10.5916 12.3583L14.1666 8.825C14.2447 8.74753 14.3067 8.65536 14.349 8.55381C14.3913 8.45226 14.4131 8.34334 14.4131 8.23333C14.4131 8.12332 14.3913 8.0144 14.349 7.91285C14.3067 7.8113 14.2447 7.71913 14.1666 7.64166Z"
      fill="currentColor"
    />
  </SvgIcon>
);

AngleIcon.displayName = 'AngleIcon';
